import $ from "@modules/jquery";

export default () => {
    $('.titleSubtitleYearFilterBlock').each(function(i, elem) {

        var $select = $(elem).find('select');
        var $panels = $(elem).find('div[data-panel]');
        
        // Hide all panels
        $panels.hide();
        
        // Show the panel corresponding to the first select option
        var firstPanelValue = $select.find('option:first').val();
        $(elem).find('div[data-panel="' + firstPanelValue + '"]').fadeIn();
        
        // Bind change event to the select element
        $select.on('change', function() {
        var selectedValue = $(this).val();
        
        // Hide all panels and fade in the selected panel
        $panels.hide();
        $(elem).find('div[data-panel="' + selectedValue + '"]').fadeIn();
    });
    });
};